// frontend/src/components/Common/NotificationBell/NotificationBell.jsx
import React, { useState, useEffect, useRef } from 'react';
import { FiBell } from 'react-icons/fi';
import { useNotifications } from '../../../hooks/useNotifications';
import NotificationPanel from './NotificationPanel';
import './NotificationBell.css';

const NotificationBell = () => {
  const [showPanel, setShowPanel] = useState(false);
  const bellRef = useRef(null);
  const { unreadCount, notifications, loading, fetchNotifications, fetchUnreadCount, markAsRead, markAllAsRead, deleteNotification, refresh, startPolling, stopPolling } = useNotifications();

  // Fetch badge count immediately on mount (empty deps = runs once)
  useEffect(() => {
    fetchUnreadCount();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Then poll every 60s for updates
  useEffect(() => {
    const id = setInterval(fetchUnreadCount, 60000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Load full list when panel opens
  useEffect(() => {
    if (showPanel) {
      fetchNotifications();
    }
  }, [showPanel, fetchNotifications]);

  // Close panel when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setShowPanel(false);
      }
    };

    if (showPanel) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPanel]);

  const handleTogglePanel = () => {
    setShowPanel(!showPanel);
  };

  return (
    <div className="notification-bell-container" ref={bellRef}>
      <button 
        className="notification-bell-button"
        onClick={handleTogglePanel}
        title="Notifications"
      >
        <FiBell size={20} />
        {unreadCount > 0 && (
          <span className="notification-bell-badge">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {showPanel && (
        <NotificationPanel
          notifications={notifications}
          loading={loading}
          onClose={() => setShowPanel(false)}
          onMarkAsRead={markAsRead}
          onMarkAllAsRead={markAllAsRead}
          onDelete={deleteNotification}
          onRefresh={refresh}
        />
      )}
    </div>
  );
};

export default NotificationBell;